import Vue from 'vue';
import VueI18n from 'vue-i18n';

// Languages json
import EN from '@/languages/EN/translations.json';
import ES from '@/languages/ES/translations.json';

Vue.use(VueI18n)
export const i18n = new VueI18n({
    locale: 'EN',
    fallbackLocale: 'EN',
    messages: {
        EN,
        ES
    }
})